import React from "react";
import { useSelector } from "react-redux";
import classes from "./InputCharLimit.module.css";

const InputCharLimit = ({ limitNum, label, value, setValue, name, style, type, dropClass }) => {

    const texts = useSelector(state => state.translate.texts);


    return <div className={classes.InputCharLimit}>
        <div className={classes.InputLabel}>
            <div className={classes.Title}>{label}</div>
            <div className={classes.UpToCharacters}>({texts.upTo} {limitNum} {texts.characters})</div>
        </div>
        <div className={classes.InputWrap}>
            {type === "input" ? <input type='text'
                name={name}
                className={`${dropClass} ${classes.Input}`}
                value={value}
                onChange={(e) => { setValue(name, e.target.value) }}
                style={style}
                maxLength={limitNum} />
                :
                <textarea name={name}
                    className={`${dropClass} ${classes.Input}`}
                    value={value}
                    onChange={(e) => { setValue(name, e.target.value) }}
                    style={style}
                    maxLength={limitNum} />
            }
            <div className={classes.CharactersNum}>{value ? value.length : 0}/{limitNum} {texts.characters}</div>
        </div>
    </div>
}

export default InputCharLimit;